import {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import SwitchMod from '../../../global/SwitchMod';
import { useDispatch, useSelector } from 'react-redux';
import { bajaUsuariosAction, obtenerUsuariosAction } from "./../../../ducks/usuariosDuck";
import ButtonEdit from '../../../global/ButtonEdit';
import ButtonResetPass from '../FChangePass';

const columns = [
  { id: "usurio", minWidth: 150, align: "center", label: 'Usuario' },
  { id: "Correo", minWidth: 150, align: "center", label: 'Correo' },
  { id: "telefono", minWidth: 150, align: "center", label: 'Teléfono' },
  { id: "rol", minWidth: 150, align: "center", label: 'Rol' },
  { id: "Estatus", minWidth: 150, align: "center", label: 'Estatus' },
  { id: "action", minWidth: 50, align: "center", label: "" },
  { id: "action2", minWidth: 50, align: "center", label: "" }
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function TUsuarios({rows, onEditar = () =>{}}) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {IdTipoUsuario} = useSelector(store => store.usuarios)
  const onEdit = (rowItem) =>{
    onEditar(rowItem)
  }
  const onChangeSwitch = (SwitchValue, SwitchCheked) =>{
    const valEstatus = SwitchCheked ? 1 : 0;
    dispatch(bajaUsuariosAction(SwitchValue, valEstatus)).then((Response) =>{
      dispatch(obtenerUsuariosAction(IdTipoUsuario))
    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.Id}>
                      <TableCell align='center'>
                        {`${row.Informacion.Nombre} ${row.Informacion.ApellidoPaterno} ${row.Informacion.ApellidoMaterno}`}
                      </TableCell>
                      <TableCell align="center">{row.Email}</TableCell>
                      <TableCell align="center">{row.Informacion.Telefono}</TableCell>
                      <TableCell align='center'>{row.Rol.Name}</TableCell>
                      <TableCell align="center">
                        <SwitchMod
                          Name={`${row.Id}-Switch-${index}`}
                          Id={row.Id}
                          Estatus={row.Informacion.Estatus}
                          onChangeSwitch={onChangeSwitch}
                        />
                      </TableCell>
                      <TableCell>
                        <ButtonEdit onClick={() =>{onEdit(row)}} />
                      </TableCell>
                      <TableCell>
                        <ButtonResetPass row={row} />
                      </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}